// extracted by mini-css-extract-plugin
module.exports = {"name":"_1hcD0a_bSyiR3onUpeROse","email":"mE__YuwzaJWlkSlTsT0Ue","phone":"_2SylbY2najL_pFBHwnUOJE","error":"_3gCDM2dZ-6mKTobHfGXDe5"};